import React, { cloneElement, use, useEffect, useRef, useState } from "react";
import { message, Tooltip, Upload, UploadFile, UploadProps } from "antd";
import http from "../../http";
import styles from "./upLoad.module.scss";
import { UploadOutlined } from "@ant-design/icons";
export const accept = [".zip", ".rar", ".7z", ".tar", ".gz", ".tgz"];
export default function UpLoad(props: {
  disabled?: boolean;
  onUpLoadChange: (file: UploadFile) => void;
  onUpLoadDrop?: () => void;
  dragger?: boolean;
  children?: JSX.Element;
  url: string;
  showUploadList?: boolean;
}) {
  const { Dragger } = Upload;
  const {
    disabled = false,
    dragger = false,
    onUpLoadChange,
    onUpLoadDrop,
    url,
    showUploadList = false,
  } = props;
  const upLoad = useRef<any>();
  const children = props?.children
    ? cloneElement(props.children, {
        onClick: () => {
          upLoad?.current && upLoad?.current?.click();
        },
      })
    : null;

  const uoLoadProps: UploadProps = {
    name: "file",
    action: url,
    headers: {
      authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    disabled: disabled,
    maxCount: 1,
    accept: accept.join(","),
    showUploadList: showUploadList,
    beforeUpload: (file) => {
      let isAccept = false;
      accept.map((item) => {
        if (file.name.toLowerCase().includes(item)) {
          isAccept = true;
        }
      });
      if (!isAccept) {
        message.warning(`${file.name} 文件格式不支持`);
        return false;
      }
    },
    onChange(info) {
      if (info.file.status) {
        onUpLoadChange(info.file);
      }
    },
    onDrop(e) {
      onUpLoadDrop?.();
    },
  };
  return dragger ? (
    <Dragger {...uoLoadProps} style={{ zIndex: 999 }}>
      <UploadOutlined style={{ fontSize: 36 }} />
      <div className={styles.dragover_text}>在此处拖放文件</div>
      <div className={styles.dragover_accept}>
        支持文件类型：
        {accept.map((ext) => ext.slice(1)).join(", ")}
      </div>
    </Dragger>
  ) : (
    <Tooltip placement="top" title={"点击此处上传文件"}>
      <Upload {...uoLoadProps}>{children}</Upload>
    </Tooltip>
  );
}
